import { Form } from '@components'
import { Button, CardActions, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Card from '../Card'
import { UseFormReturn } from 'react-hook-form'
import { OptionalObjectSchema } from 'yup/lib/object'
import { useAppDispatch } from '@hooks'
import { filterRedux } from '@store'
import { pickBy } from 'lodash'

interface TableFilterProps {
  form: UseFormReturn<any>
  schema: OptionalObjectSchema<any>
  onFilter: (values: any) => void
  initial: Object
  persistObject: string
}

const StyledCardActions = styled(CardActions)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: 20,
}))

const TableFilter = (props: TableFilterProps) => {
  const { form, schema, onFilter, initial, persistObject } = props
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const filter = (values: any) => {
    const _values = pickBy(values, (item: any) => item)
    onFilter(_values)
    dispatch(filterRedux.setFilter({ name: persistObject, data: values }))
  }

  return (
    <Card sx={{ mb: 4, pt: 4 }}>
      <Form form={form} schema={schema} />
      <StyledCardActions>
        <Button
          onClick={() => {
            dispatch(filterRedux.clearFilter({ name: persistObject }))
            form.reset(initial)
            filter(initial)
          }}
          variant="outlined"
        >
          {t('clear')}
        </Button>
        <Button variant="contained" onClick={form.handleSubmit(filter)}>
          {t('filter')}
        </Button>
      </StyledCardActions>
    </Card>
  )
}

export default TableFilter
